/** Unidades federativas do Brasil: 26 estados + Distrito Federal. */

export const UFS = [
  'AC',
  'AL',
  'AP',
  'AM',
  'BA',
  'CE',
  'DF',
  'ES',
  'GO',
  'MA',
  'MT',
  'MS',
  'MG',
  'PA',
  'PB',
  'PR',
  'PE',
  'PI',
  'RJ',
  'RN',
  'RS',
  'RO',
  'RR',
  'SC',
  'SP',
  'SE',
  'TO',
] as const;

export type Uf = (typeof UFS)[number];

/** Verifica se a sigla (ignorando espaços e caixa) é uma UF válida. */
export function validarUf(valor: string): boolean {
  const uf = valor.trim().toUpperCase();
  return (UFS as readonly string[]).includes(uf);
}
